export const baseUrl = 'denticare';

export const ApiDenticareClient = {
  Client: `${baseUrl}/client/register`,
  Status: `${baseUrl}/client/status`
};
